import Component from "gia/Component";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    const newDomain = "https://track.bdkparfums.com";
    const url = new URL(window.location.href);
    console.log(url);
    const test1 = url.pathname.indexOf("/fr_fr/order/");
    const test2 = url.pathname.indexOf("/eu_fr/order/");
    const test3 = url.pathname.indexOf("/us_fr/order/");
    const test4 = url.pathname.indexOf("/fr_en/order/");
    const test5 = url.pathname.indexOf("/eu_en/order/");
    const test6 = url.pathname.indexOf("/us_en/order/");
    if (
      test1 >= 0 ||
      test2 >= 0 ||
      test3 >= 0 ||
      test3 >= 0 ||
      test4 >= 0 ||
      test5 >= 0 ||
      test6 >= 0
    ) {
      let newUrl = newDomain + url.pathname;
      window.location.href = newUrl;
    }
  }

  unmount() {}
}
